module.exports = __webpack_public_path__ + "media/images/logo_pc-b293021d6c5b0d1827000d8938066aac.png";